import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "./translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mt_lang") || "lt");

  useEffect(() => {
    localStorage.setItem("mt_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = useCallback(() => setLang((l) => (l === "lt" ? "en" : "lt")), []);

  const t = useCallback(
    (path, vars = {}) => {
      const parts = path.split(".");
      let node = translations[lang];
      for (const p of parts) {
        if (node && p in node) node = node[p];
        else return path;
      }
      if (typeof node === "string") {
        return node.replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? `{${k}}`);
      }
      return node;
    },
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};

// Helper to pick localized value from data objects like { lt: "...", en: "..." }
export const pick = (obj, lang) => {
  if (obj == null) return "";
  if (typeof obj === "string") return obj;
  return obj[lang] ?? obj.lt ?? obj.en ?? "";
};
